import React, {Component,Fragment} from 'react';
import {BeatLoader} from 'react-spinners';
import Datetime from 'react-datetime'
import '../../../../../node_modules/react-datetime/css/react-datetime.css';
import {get, post,postResponse, postWithHeaders} from "../../../../server/actions";
import NotificationSystem from 'react-notification-system';
import { Draggable, Droppable } from 'react-drag-and-drop';
import {_addNotification,_addNotificationError} from '../../../../server/util';
import Modal from 'react-modal';
import $ from 'jquery';
import moment from  'moment';
import MenuCal from './menuCal'
const caterer=sessionStorage.getItem('CatererId')||0;
const menuType={
    lunch:'Lunch',
    'breakfast':'Breakfast'
}
const newMealObj={
    title: "",
    start: null,
    id: ""
  }
const styles={
    menuItemStyle:{
        padding: '5px',
        border: '1px solid #ccc',
        textAlign:'left',
        color:'#fff',
        cursor: 'move'
    },
    calenderHeader:{
        cursor: 'pointer',
        textDecoration:'underline',
    },
    customManageUsersStyles :{content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }}
      
}
class NewMenu extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            menuItemSearch:'',
            currentDate:moment(),  
            showModal:false,
            orderedMenu:{},
            calendarEvents: [],
            events: [],
            deleteMenu:{}
        }
        this.getSelectedMonthMenu=this.getSelectedMonthMenu.bind(this);
        this.getMealItems=this.getMealItems.bind(this);
        this.saveMonthMenu=this.saveMonthMenu.bind(this);
    }
    componentWillMount=()=>{
        this.getMealItems();
    }    
    componentDidMount=()=> {
        this._notificationSystem = this.refs.notificationSystem;
        this.getSelectedMonthMenu(this.state.currentDate.format('YYYYMM'));
    }
    getSelectedMonthMenu=(_yearMonth)=>{
        this.setState({loading: true})
        get('/caterer/'+caterer+'/menuCalendars?yearMonth='+_yearMonth+'&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuCalendar=data.slice()||[];
            let _calenderEvents=[];
            if(_menuCalendar.length>0){
                (_menuCalendar[0].mealByDays||[]).map((item,k)=>{
                    _calenderEvents.push({
                        title:item.menuCatalog.mealName,
                        date:moment(item.date).format('YYYY-MM-DD'),
                        id:item.menuCatalog.id
                    })
                })
            }
            this.setState({
                loading: false,
                orderedMenu: data.length>0? data[0]:{},
                calendarEvents:_calenderEvents
            });
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get SchoolDistricts response', error)
            }
        );

    }
    getMealItems=()=>{
        this.setState({loading: true})
        get('/menuCatalogs?page=0&size=25235525&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItems=data._embedded.menuCatalogs||[];
            this.setState({loading: false,events:_menuItems})
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get SchoolDistricts response', error)
            }
        );
    }
    saveMonthMenu=()=>{
        this.setState({loading: true})
        const headers = {
            'Content-Type': 'application/json'
        };
        const body=JSON.parse(JSON.stringify(this.state.orderedMenu));
        let _mealByDays=[];
        this.state.calendarEvents.map(item=>{
            _mealByDays.push({
               // "id": 0,
                "date": moment(item.date,'YYYY-MM-DD'),
                "menuCatalog": {
                    "id": item.id
                }
            })

        });
        body.catering={id:caterer}
        body.mealType=menuType.lunch;
        body.yearMonth= this.state.currentDate.format('YYYYMM')
        body.mealByDays=_mealByDays;
        postWithHeaders('/menuCalendars?access_token=',JSON.stringify(body), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            this.setState({loading: false})
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message,this); 
            }
        );

    }
    render(){
        return(
        <Fragment>
            <div className="container">
                <section className="full-width clearfix">
                    <NotificationSystem ref="notificationSystem"/>
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row">
                        <div className="sectionTitle">
                            <h2>New Menu</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="panel panel-primary">
                            <div className="panel-heading">Menu Items</div>
                            <ul className="list-group">
                                <li className="list-group-item list-group-item-default">
                                <input type="text" 
                                name="menuItemSearch" 
                                placeholder="Search.." 
                                className="form-control" onChange={(e)=>{
                                    this.setState({menuItemSearch:e.target.value})
                                }} /></li>
                            </ul>
                            <ul className="list-group">
                                {
                                    (this.state.events.filter(ev=> (ev.mealName||'').toLowerCase().includes(this.state.menuItemSearch.toLowerCase()))||[])
                                    .map(event => {
                                        let id=event._links.self.href.split('/').pop();
                                       return <Draggable type="menu" data={id}>
                                            <li className="list-group-item bg-color-5" style={styles.menuItemStyle}>{event.mealName}
                                            </li>
                                        </Draggable>    
                                    })
                                }
                            </ul>
                            </div>          
                        </div>
                        <div className="col-md-9">
                            <div className="panel panel-info"> 
                            <div className="panel-heading">
                            <div className="row"><div className="col-md-12">                                
                            <Datetime 
                                    ref='calendar' 
                                    value={this.state.currentDate}
                                    dateFormat="MMMM YYYY"
                                    input={true}
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    isValidDate={(currentDate)=>{
                                       // let minDate=moment();
                                        //minDate.set({hour:0,minute:0,second:0,millisecond:0})
                                       // currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                      //  return (minDate<currentDate) ;
                                      return true;
                                      }}
                                    renderInput={(props, openCalendar, closeCalendar) => {
                                        return (
                                            <label style={styles.calenderHeader} onClick={openCalendar}>                                                
                                                {'Menu for '+moment(this.state.currentDate).format('MMM-YYYY')+' '} 
                                                 <i className="fa fa-calendar" aria-hidden="true"></i>                                                                        
                                            </label>
                                        );
                                    }}                           
                                    onChange={(e)=>{
                                        this.setState({currentDate:e},
                                            this.getSelectedMonthMenu(e.format('YYYYMM'))
                                        );
                                    }} 
                                    />
                            </div></div>                                
                            </div>                                             
                            <div className="panel-body" id="mycalendartest"> 
                                <MenuCal events={this.state.calendarEvents} selectedDate={this.state.currentDate}
                                onEventDrag={(event)=>{
                                   let _calEvents= this.state.calendarEvents;
                                   _calEvents.push(event);
                                   this.setState({calendarEvents:_calEvents})
                                }} deleteMenuItem={(menuId,menuDate)=>{
                                    this.setState({showModal:true,deleteMenu:{menuId:menuId,menuDate:menuDate}})
                                }} itemList={this.state.events}  />

                            </div>
                            <div className="panel-footer">
                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <button type="button" className="btn btn-xs btn-danger">Cancel</button>
                                        <button type="button" className="btn btn-xs btn-success" 
                                        onClick={(e)=>{
                                            this.saveMonthMenu();
                                        }}>Save</button>
                                    </div>
                                </div>
                            </div>
                            </div>            
                        </div>
                    </div>           
                </section>
            </div>
                <Modal isOpen={this.state.showModal}
                 onRequestClose={()=>{this.setState({showModal:false,deleteMenu:{}})}}
                    style={styles.customManageUsersStyles}
                    contentLabel="Example Modal">
                     <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Delete menu item conformation</h4>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete meal item?</p>                            
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ showModal: false,deleteMenu:{} })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                    let _delItem=this.state.deleteMenu
                                    let idx=this.state.calendarEvents.findIndex(item=>{
                                        return _delItem.menuId==item.id && _delItem.menuDate==item.date
                                    })
                                    if(idx!==-1){
                                        let _calenderEvents=this.state.calendarEvents.slice();
                                        _calenderEvents.splice(idx, 1); 
                                        this.setState({calendarEvents:_calenderEvents,showModal:false,deleteMenu:{}})
                                    }

                                }}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                            </button>
                    </div>
                </Modal>
        </Fragment>)
    }
}
export default NewMenu 


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/NewMenu/newMenu.jsx